import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import clientService from '../../../services/clientService';

const ClientFilter = ({ value, onChange, showLabel = true, className = '' }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadClients();
  }, []);

  const loadClients = async () => {
    try {
      setLoading(true);
      const result = await clientService.getClients();
      if (result.success && result.data) {
        setClients(result.data);
      }
    } catch (error) {
      console.error('Error loading clients:', error);
    } finally {
      setLoading(false);
    }
  };

  const clientOptions = [
    { value: 'all', label: 'All Clients' },
    ...(clients.map(client => ({
      value: client.id,
      label: client.company_name || client.name || 'Unknown Client'
    })))
  ];

  return (
    <div className={className}>
      {showLabel && (
        <label className="block text-sm font-medium text-foreground mb-2">
          <Icon name="Building2" size={14} className="inline mr-1" />
          Client
        </label>
      )}
      <Select
        value={value || 'all'}
        onChange={(selectedValue) => onChange && onChange(selectedValue === 'all' ? null : selectedValue)}
        options={clientOptions}
        disabled={loading}
        className="w-full"
      />
      {loading && (
        <p className="text-xs text-muted-foreground mt-1">Loading clients...</p>
      )}
    </div>
  );
};

export default ClientFilter;

